import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION4: PdfComponent = {
  type: 'section',
  id: 's4',
  title: '4. Rights and Duties of Subscriber',
  content: [
    {
      type: 'bulletList',
      id: 's4bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Subscriber shall discharge its obligations under this Agreement:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'in a timely, professional and efficient manner; and',
              },
              {
                copy: 'in accordance with Applicable Law and Good Industry Practice.',
              },
            ],
          },
        },
        {
          copy: 'During the Term, the Subscriber shall:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'ensure that Subscriber sales staff (if any) are trained in accordance with any instructions, materials, or procedural guidance provided or notified by Kanda from time to time;',
              },
              {
                copy: "espond, without undue delay, to all Customer requests for disclosure of any fees paid to the Subscriber and/or Kanda in connection with the Customer's application for credit;",
              },
              {
                copy: "assist Kanda with its reporting obligations by providing reasonable information as requested by Kanda to assess the Subscriber's financial and operational standing, including but not limited to:",
                sublist: {
                  bulletType: 'roman',
                  content: [
                    {
                      copy: "a summary of the Subscriber's performance against its service levels (where applicable) and the status of any remedial action;",
                    },
                    {
                      copy: 'a summary of complaints activity relating to the Subscriber (including any relevant ratings or classifications) and the status of any remedial action;',
                    },
                  ],
                },
              },
              {
                copy: 'act diligently and in good faith towards Kanda and all Customers;',
              },
              {
                copy: "seek to enhance the reputation of Kanda and the credit facilities offered through Kanda's platform, and not do or omit to do anything that may adversely affect or harm their reputation, brand, or operations;",
              },
              {
                copy: 'obtain and maintain all authorisations, approvals, permissions, consents, and licences necessary from time to time to perform its obligations under or in connection with this Agreement.',
              },
            ],
          },
        },
      ],
      prefix: '3',
    },
  ],
};
